define.alias("shared/components/shared/pre-boarding/auto-trial-start/index", "media/components/shared/pre-boarding/auto-trial-start/index");